<template>
    <div class="progress-bar">
        <p v-if="props.label" class="progress-bar--label">{{ props.label }}</p>
        <div class="progress-bar--component">
            <div class="progress-bar--component--container">
                <ProgressBar
                    :value="props.value"
                    :show-value="false"
                    :dt="customStyle"
                    v-bind="$attrs"
                ></ProgressBar>
            </div>
            <p v-if="props.showValue" class="progress-bar--component--value">
                {{ props.value }}%
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ProgressBar from 'primevue/progressbar'

interface Props {
    label?: string
    value: number
    showValue?: boolean
    barColor?: string
    backgroundColor?: string
    maxWidth?: string
}
const props = withDefaults(defineProps<Props>(), {
    label: '',
    showValue: true,
    barColor: '{primary.500}',
    backgroundColor: '{gray.200}',
    maxWidth: '100%',
})

const customStyle = computed(() => ({
    valueBackground: props.barColor,
    background: props.backgroundColor,
    height: '8px',
}))
</script>

<style lang="less" scoped>
@import '@/styles/prime-vue/variables.less';
.progress-bar {
    &--label {
        margin: 0;
    }

    &--component {
        display: flex;
        align-items: center;
        max-width: v-bind('$props.maxWidth');

        &--container {
            flex: 1;
        }

        &--value {
            margin-left: @spacing-lg;
            margin-top: 0;
            margin-bottom: 0;
        }
    }
}
</style>
